// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({535: "lib-router",783: "lib-react",}[chunkId] || chunkId) + "." + {10: "68c2421a4a",157: "8a523a6e84",266: "fbfc6a9b35",317: "24bf0b16bb",362: "9e836edcd6",487: "d99566ddb7",531: "86be04fef6",535: "ce9598017c",556: "64f5213fe2",564: "1d75cc3d5d",588: "d91aae150e",743: "3b7f1656d1",783: "797dcb5662",904: "f03539c717",945: "298959f0e6",}[chunkId] + ".js"
}